import React from 'react';
import PropTypes from 'prop-types';

import ContractStatusLabel from '../../ContractStatusLabel';
import ContractPickerDates from '../ContractPickerDates';
import ContractPickerNoMaster from '../ContractPickerNoMaster';

const ContractPickerValue = ({ value, children }) => (
  <div className="Select-value" title={value.title}>
    <span className="Select-value-label">
      <strong>{children || value.number}</strong>
      <ContractPickerDates
        startDate={value.startDate}
        endDate={value.endDate}
        showPlan={value.showPlan}
        plan={value.plan}
      />
      <ContractStatusLabel status={value.status} />
      <ContractPickerNoMaster hasMasterTenant={!!value.masterTenantId} />
    </span>
  </div>
);

ContractPickerValue.propTypes = {
  children: PropTypes.node,
  value: PropTypes.object
};

export default ContractPickerValue;
